<template>
    <div>
        <div class="hidden help-title">WEAT Help</div>
        <p>
            Analyzing a large dataset like the BRFSS dataset can be difficult
            and confusing. The Web Enabled Analysis Tool (WEAT) is a tool that
            can be used to simplify the process. To create an analysis using
            WEAT, select one of the options (Cross Tabulation or Logistic
            Regression) on the Analysis page to get started.
        </p>
        <p>
            There are two levels of help in WEAT: Inline help and these help
            documents.
        </p>
        <h3>Inline Help</h3>
        <p>
            First, as you navigate through the selection page, be sure to
            identify the 'Help with this step...' box on the bottom left.
        </p>
        <img
            v-bind:src="helpWithThisStep"
            alt="Image of the 'Help with this step' box"
            title="The inline help box"
        />
        <p>
            This box will give you information about the step you are on and
            selections you have made so far.
        </p>
        <h3>My Analysis</h3>
        <p>
            On the bottom right of the page is the "My Analysis" box. This
            contains all the selections you have made to this point, including
            the year, location, and any variables selected. You can use this
            information in conjunction with the "Help with this step..." box to
            understand the current implications of your selections, and what to
            do next.
        </p>
        <p>
            "My Analysis" also contains the number of source records and
            estimated execution time for the selections you have made. As you
            make selections, you can see how that affects the time it will take
            to run the analysis, and the number of survey respondents that will
            be included in the analysis. There is a limit of 2 minutes for a
            single analysis, so you will be required to modify your selections
            to reduce the time if the analysis is too complex.
        </p>
        <p>Examples are below...</p>
        <div>
            <div class="col-xs-12 col-md-6">
                <h4>Cross Tabulation</h4>
                <img
                    v-bind:src="ctMyAnalysis"
                    alt="A Cross Tabulation My Analysis example"
                    title="A Cross Tabulation My Analysis example"
                />
            </div>
            <div class="col-xs-12 col-md-6">
                <h4>Logistic Regression</h4>
                <img
                    v-bind:src="lrMyAnalysis"
                    alt="A Logistic Regression My Analysis example"
                    title="A Logistic Regression My Analysis example"
                />
            </div>
        </div>
        <h3>Comparing Years and Locations</h3>
        <p>
            WEAT has the capability to use selected years or locations (states
            and territories) as a variable for analysis. If you select "compare"
            on the year or location selection page, then:
        </p>
        <ul>
            <li>
                You must select at least two years or locations when on the
                selection page
            </li>
            <li>
                You will not be able to continue to the report page until you
                select that new variable (years or selections) for the analysis
            </li>
        </ul>
        <p>
            Here are is what it will look like to add years as a column variable
            to a cross tabulation
        </p>
        <div>
            <div class="col-xs-12 col-md-6">
                <h4>Select Compare Years</h4>
                <img
                    v-bind:src="comparingYears"
                    alt="Select Years as Compare example"
                    title="Select Years as Compare example"
                />
            </div>
            <div class="col-xs-12 col-md-6">
                <h4>Select Year as Variable</h4>
                <img
                    v-bind:src="selectYearVariable"
                    alt="Select Years as Variable example"
                    title="Select Years as Variable example"
                />
            </div>
        </div>
        <p>
            If you instead select Combine Years or Locations, then a new
            variable will not show up on the variable selection. Instead, only
            the normal WEAT variables will be available for the analysis.
            However, all data from the selected years and locations will be
            included in the analysis.
        </p>
        <p>
            If you run into problems or questions when comparing years or
            locations, be sure to consult the help at the bottom of page.
        </p>
        <h3>Clicking Next on Selection Page</h3>
        <p>
            If the Next button does not respond when you click it, check the
            "Help with this step..." box for instructions. Most likely, the
            button doesn't respond because you have not selected more than one
            year or location when combining or comparing, or you still need to
            select a variable before continuing.
        </p>
        <h3>Additional Help</h3>
        <p>
            There are several documents included in this application to help you
            understand WEAT and the analysis it provides. For more information,
            click on one of the following:
        </p>
        <div>
            <ul>
                <li v-for="m in menuItems" v-bind:key="m.name">
                    <brfss-router-link :item="m"></brfss-router-link>
                </li>
                <!--         

          <brfss-router-link to="/userGuide/dataAnalysisFaq">Data Analysis FAQ</brfss-router-link>
        </li>
        <li>
          <brfss-router-link to="/userGuide/crossTabulation">Cross Tabulation Information</brfss-router-link>
        </li>
        <li>
          <brfss-router-link to="/userGuide/logisticRegression">Logistic Regression Information</brfss-router-link>
        </li>
        <li><brfss-router-link to="/userGuide/variables">Independent, Dependent, and Control variables</brfss-router-link></li> -->
            </ul>
        </div>
    </div>
</template>

<script>
import current from '@/scripts/current';
import brfssRouterLink from '@/components/sub/brfssRouterLink';

import navMenuItems from '@/scripts/nav/menuItems';
import helpWithThisStep from '@/assets/helpWithThisStep.png';
import ctMyAnalysis from '@/assets/ctMyAnalysis1.png';
import lrMyAnalysis from '@/assets/lrMyAnalysis1.png';
import selectYearVariable from '@/assets/selectYearVariable1.png';
import comparingYears from '@/assets/comparingYears1.png';

export default {
    components: {
        brfssRouterLink
    },
    created: function () {
        const vm = this;
        const m = navMenuItems.menuItems.byName;
        vm.menuItems = [
            m.userGuideDataAnalysisFAQ,
            m.userGuideCrossTabulation,
            m.userGuideLogisticRegression,
            m.userGuideVariables
        ];
    },
    data: function () {
        current.initializeHelp();
        return {
            menuItems: [],
            helpWithThisStep,
            ctMyAnalysis,
            lrMyAnalysis,
            selectYearVariable,
            comparingYears
        };
    },
    methods: {}
};
</script>

<style scoped>
</style>
